import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))

// Authorization routes nested under Settings (/settings/authorization/*)
const AuthorizationRoutes: RouteObject = {
    path: 'authorization',
    children: [
        {
            path: '',
            element: <List />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AuthorizationRoutes
